<template>
  <remote-modal
    modal-class="candidate-details-modal"
    :modal-title="modalTitle"
    ref="remoteModal"
    @details-loaded="candidateDetailsLoaded"
  >
    <template
      v-if="hasDetails"
      #modal-content
    >
      <div class="row gx-2">
        <div class="col mb-2">
          <label class="form-label">Created by</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.created_by_name"
          >
        </div>
        <div class="col mb-2">
          <label class="form-label">Created at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.created_at"
          >
        </div>
      </div>
      <div
        v-if="showSelected"
        class="row gx-2"
      >
        <div class="col mb-2">
          <label class="form-label">Selected by</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.selected_by_name"
          >
        </div>
        <div class="col mb-2">
          <label class="form-label">Selected at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.selected_at"
          >
        </div>
      </div>
      <div
        v-if="showInvited"
        class="row gx-2"
      >
        <div class="col mb-2">
          <label class="form-label">Invited by</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.invited_by_name"
          >
        </div>
        <div class="col mb-2">
          <label class="form-label">Invited at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.invited_at"
          >
        </div>
      </div>
      <div
        v-if="showRegistered"
        class="row gx-2"
      >
        <div class="col mb-2">
          <label class="form-label">Registered by</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.registered_by_name"
          >
        </div>
        <div class="col mb-2">
          <label class="form-label">Registered at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.registered_at"
          >
        </div>
      </div>
      <div
        v-if="showCanceled"
        class="row gx-2"
      >
        <div class="col mb-2">
          <label class="form-label">Canceled by</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.canceled_by_name"
          >
        </div>
        <div class="col mb-2">
          <label class="form-label">Canceled at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.canceled_at"
          >
        </div>
      </div>
      <div
        v-if="showCanceledReason"
        class="row gx-2"
      >
        <div class="col mb-2">
          <label class="form-label">Cancelation reason</label>
          <textarea
            v-model="details.cancelation_reason"
            type="text"
            readonly
            class="form-control"
          />
        </div>
      </div>
      <div
        v-if="details.show_survey"
        class="row gx-2"
      >
        <div class="col-auto mb-2">
          <label class="form-label">Survey completed</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.survey_completed ? 'Yes' : 'No'"
          >
        </div>
      </div>
      <div
        v-if="showReimbursement"
        class="row gx-2"
      >
        <div class="col mb-2">
          <label class="form-label">Reimbursement sent at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.reimbursement_sent_at"
          >
        </div>
        <div class="col mb-2">
          <label class="form-label">Reimbursement reminder sent at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.reimbursement_reminder_sent_at"
          >
        </div>
      </div>
      <div
        v-if="showReimbursement"
        class="row gx-2"
      >
        <div class="col mb-2">
          <label class="form-label">Reimbursement completed at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.reimbursement_completed_at"
          >
        </div>
        <div class="col mb-2">
          <label class="form-label">Reimbursement uploaded at</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.reimbursement_uploaded_at"
          >
        </div>
      </div>
      <div
        v-if="details.show_additional_survey"
        class="row gx-2"
      >
        <div class="col-auto mb-2">
          <label class="form-label">Additional survey completed</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.additional_survey_completed ? 'Yes' : 'No'"
          >
        </div>
      </div>
      <div
        v-if="showRegistrationURL"
        class="row gx-2"
      >
        <div class="col-sm-12 mb-2">
          <label class="form-label">Reigstration URL</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.registration_url"
          >
        </div>
      </div>
      <div
        v-if="showReimbursementURL"
        class="row gx-2"
      >
        <div class="col-sm-12 mb-2">
          <label class="form-label">Reimbursement URL</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.reimbursement_url"
          >
        </div>
      </div>
      <div
        v-if="details.show_additional_survey"
        class="row gx-2"
      >
        <div class="col-sm-12 mb-2">
          <label class="form-label">Additional survey URL</label>
          <input
            type="text"
            readonly
            class="form-control"
            :value="details.additional_survey_url"
          >
        </div>
      </div>
    </template>
  </remote-modal>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from 'vue'
import RemoteModal from './remote-modal.vue'

interface CandidateDetails {
  invited_at: string | null;
  invited_by_name: string | null;
  selection_status_id: number | null;
  selected_by_name: string | null;
  selected_at: string | null;
  registered_at: string | null;
  registered_by_name: string | null;
  reimbursement_sent_at: string | null;
  reimbursement_uploaded_at: string | null;
  reimbursement_reminder_sent_at: string | null;
  reimbursement_completed_at: string | null;
  reimbursement_url: string | null;
  registration_url: string | null;
  canceled_by_name: string | null;
  canceled_at: string | null;
  cancelation_reason: string | null;
  created_by_name: string | null;
  created_at: string | null;
  show_survey: boolean;
  survey_completed: boolean;
  show_additional_survey: boolean;
  additional_survey_url: string | null;
  additional_survey_completed: boolean;
}

interface CandidateDetailsResponse extends CandidateDetails {
  full_name: string;
}

const remoteModal = useTemplateRef<InstanceType<typeof RemoteModal>>('remoteModal')

const candidateDetails: CandidateDetails = {
  invited_at: null,
  invited_by_name: null,
  selection_status_id: null,
  selected_by_name: null,
  selected_at: null,
  registered_at: null,
  registered_by_name: null,
  reimbursement_sent_at: null,
  reimbursement_uploaded_at: null,
  reimbursement_reminder_sent_at: null,
  reimbursement_completed_at: null,
  reimbursement_url: null,
  registration_url: null,
  canceled_by_name: null,
  canceled_at: null,
  cancelation_reason: null,
  created_by_name: null,
  created_at: null,
  show_survey: false,
  survey_completed: false,
  show_additional_survey: false,
  additional_survey_completed: false,
  additional_survey_url: null,
}

const modalTitle = ref('Candidate/Participant details')
const details = ref<CandidateDetails>(candidateDetails)
const hasDetails = ref(false)

const hasValue = (val: unknown): boolean => {
  if (typeof val === 'undefined' || val === null) {
    return false
  }

  if (typeof val === 'string' && val.length == 0) {
    return false
  }

  return true
}

const showInvited = computed((): boolean => {
  return hasValue(details.value) && (hasValue(details.value.invited_at) || hasValue(details.value.invited_by_name))
})

const showSelected = computed((): boolean => {
  return hasValue(details.value) && hasValue(details.value.selection_status_id) && details.value.selection_status_id !== 1
})

const showRegistered = computed((): boolean => {
  return hasValue(details.value)
})

const showReimbursement = computed((): boolean => {
  return hasValue(details.value) && (hasValue(details.value.reimbursement_sent_at) ||
    hasValue(details.value.reimbursement_uploaded_at) ||
    hasValue(details.value.reimbursement_completed_at)) ||
    hasValue(details.value.reimbursement_reminder_sent_at)
})

const showRegistrationURL = computed((): boolean => {
  return hasValue(details.value) && hasValue(details.value.registration_url)
})

const showReimbursementURL = computed((): boolean => {
  return hasValue(details.value) && hasValue(details.value.reimbursement_url)
})

const showCanceled = computed((): boolean => {
  return hasValue(details.value) && hasValue(details.value.selection_status_id) && details.value.selection_status_id === 3
})

const showCanceledReason = computed((): boolean => {
  return showCanceled.value && hasValue(details.value.cancelation_reason)
})

const showModal = (url: string): void => {
  remoteModal.value?.showModal(url)
}

const candidateDetailsLoaded = (responseData: CandidateDetailsResponse): void => {
  modalTitle.value = responseData.full_name
  hasDetails.value = true
  details.value = responseData
}

defineExpose({
  showModal,
})
</script>
